export default __webpack_public_path__ + "static/media/search.4cd82d7a.svg";